<template>
  <div>
    <v-data-table
      :headers="newheaders"
      :items="Data"
      :item-key="index"
      disable-pagination
      hide-default-footer
      class="elevation-1"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.index }}</td>
          <td>{{ item.TRANSACTION_ID }}</td>
          <td>{{ item.WALKIN_DATE | formatDate }}</td>
          <td>{{ item.CUSTOMER_NAME }}</td>
          <td>{{ item.WALKUOT_WEIGHT | delimeter }}</td>
        </tr>
      </template>
      <template slot="body.append">
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td>น้ำหนักรวม</td>
          <td>
            {{ Data[0].CAR_WEIGHT | delimeter }}
          </td>
        </tr>
        <tr>
          <td></td>
          <td></td>
          <td></td>
          <td>น้ำหนักรวมที่โรงกำจัด</td>
          <td>
            {{ Data[0].DESTROY_WEIGHT | delimeter }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "DocmentReportDash",
  props: { Data: Array },
  data() {
    return {
      newheaders: [
        {
          text: "ลำดับที่",
          align: "start",
          sortable: false,
          value: "index",
        },
        { text: "เลขที่ ตช.", value: "TRANSACTION_ID" },
        { text: "วันที่เก็บขน", value: "WALKIN_DATE" },
        { text: "แหล่งกำเนิด", value: "CUSTOMER_NAME" },
        { text: "น้ำหนัก", value: "WALKUOT_WEIGHT" },
      ],
      
    };
  },
  methods: {},
  created() { console.log(Data);},
  beforeCreate() {
   
  },
  computed: {
    
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x;
    },
    formatDate(data) {
      return moment(data).add(543, "year").format("DD-MM-YYYY");
    },
  },
};
</script>
<style scoped lang="less">
</style>